<template>
  <div class="content">
    <BasicDataPdf
      :userData="this.PersonalAreaPdf ? userData : commonUserData"
      @onImgReady="onImgReady"
    />
    <div
      class="content_grid"
      v-if="(userData && userData.employee) || (commonUserData && commonUserData.employee)"
    >
      <div class="content_grid_left">
        <IdNumberPdf :id_data="id_data" />
        <TaxNumberPdf :tax_data="tax_data" />
        <ContractPdf :contract="contract" />
        <SafetyCardPdf :safety_card="safety_card" />
        <PassportPdf :passport_data="passport_data" />
        <ValttikorttiPdf :valttikortti="valttikortti" />
        <TaxCardPdf :tax_card="tax_card" />
        <PersonalNumber v-if="admin" />
        <ContactAddressPdf :streetData="street" :cityData="city" :zipData="zip" :one="true" />
      </div>
      <div class="content_grid_right">
        <ContactAddressPdf :additional_address="additional_address" :two="true" />
        <ContactAddressPdf :additional_address="additional_address" :three="true" />
        <ContactAddressPdf :additional_address="additional_address" :four="true" />
        <ClothesSizesPdf :clothesSizes="clothesSizes" />
        <SkillsPdf :skills="skills" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import BasicDataPdf from 'components/personalArea/pdf/BasicDataPdf'
import IdNumberPdf from 'components/personalArea/pdf/IdNumberPdf'
import ContractPdf from 'components/personalArea/pdf/ContractPdf'
import SafetyCardPdf from 'components/personalArea/pdf/SafetyCardPdf'
import PassportPdf from 'components/personalArea/pdf/PassportPdf'
import ValttikorttiPdf from 'components/personalArea/pdf/ValttikorttiPdf'
import TaxNumberPdf from 'components/personalArea/pdf/TaxNumberPdf'
import ContactAddressPdf from 'components/personalArea/pdf/ContactAddressPdf'
import PersonalNumber from 'components/personalArea/PersonalNumber'
import TaxCardPdf from 'components/personalArea/pdf/TaxCardPdf'
import SkillsPdf from 'components/personalArea/pdf/SkillsPdf'
import ClothesSizesPdf from 'components/personalArea/pdf/ClothesSizesPdf'

export default {
  name: 'PersonalAreaPdfBody',
  props: ['userId'],
  components: {
    BasicDataPdf,
    IdNumberPdf,
    SafetyCardPdf,
    TaxNumberPdf,
    PersonalNumber,
    PassportPdf,
    ValttikorttiPdf,
    TaxCardPdf,
    ContractPdf,
    SkillsPdf,
    ContactAddressPdf,
    ClothesSizesPdf,
  },
  data: () => ({
    date: null,
    menu: false,
    editing: false,
    BasicDataPdf: null,
    safety_card: null,
    id_data: null,
    tax_data: null,
    passport_data: null,
    valttikortti: null,
    tax_card: null,
    contract: null,
    skills: null,
    admin: false,
    street: null,
    city: null,
    zip: null,
    additional_address: null,
    notes: null,
    clothesSizes: null,
  }),
  created() {
    if (this.PersonalAreaPdf) {
      this.getUser()
      this.onUserEmployeeDocGrid()
    } else {
      this.downloadEployeeData()
    }
  },
  computed: {
    ...mapGetters('user', ['userData', 'userEmployeeDocGrid']),
    ...mapGetters('employeeDoc', ['employeeDocGrid']),
    ...mapGetters('commonUser', ['commonUserData']),
    PersonalAreaPdf() {
      return this.$route.name === 'PersonalAreaPdf'
    },
  },
  watch: {
    userEmployeeDocGrid() {
      if (this.userEmployeeDocGrid !== null) {
        this.safety_card = this.userEmployeeDocGrid.find((i) => i.type === 'safety_card')
        this.valttikortti = this.userEmployeeDocGrid.find((i) => i.type === 'valttikortti')
        this.tax_card = this.userEmployeeDocGrid.find((i) => i.type === 'tax_card')
        this.contract = this.userEmployeeDocGrid.find((i) => i.type === 'contract')
        this.additional_address = this.userEmployeeDocGrid.find(
          (i) => i.type === 'additional_address',
        )
      }
    },
    employeeDocGrid() {
      if (this.employeeDocGrid !== null) {
        this.safety_card = this.employeeDocGrid.find((i) => i.type === 'safety_card')
        this.valttikortti = this.employeeDocGrid.find((i) => i.type === 'valttikortti')
        this.tax_card = this.employeeDocGrid.find((i) => i.type === 'tax_card')
        this.contract = this.employeeDocGrid.find((i) => i.type === 'contract')
        this.additional_data = this.employeeDocGrid.find((i) => i.type === 'additional_data')
        this.additional_address = this.employeeDocGrid.find((i) => i.type === 'additional_address')
      }
    },
    userData() {
      if (this.userData.employee) {
        this.id_data = JSON.parse(this.userData.employee.id_data)
        this.tax_data = JSON.parse(this.userData.employee.tax_data)
        this.passport_data = JSON.parse(this.userData.employee.passport_data)
        this.street = this.userData.employee.street
        this.city = this.userData.employee.city
        this.zip = this.userData.employee.zip
        this.notes = JSON.parse(this.userData.employee.notes)
        this.clothesSizes = {
          size_shoes: this.userData.employee.size_shoes,
          size_jacket: this.userData.employee.size_jacket,
          size_pants: this.userData.employee.size_pants,
          size_gloves: this.userData.employee.size_gloves,
        }
        this.skills = this.userData.employee.work_types
      }
    },
    commonUserData() {
      if (this.commonUserData && this.commonUserData.employee) {
        this.id_data = JSON.parse(this.commonUserData.employee.id_data)
        this.tax_data = JSON.parse(this.commonUserData.employee.tax_data)
        this.passport_data = JSON.parse(this.commonUserData.employee.passport_data)
        this.street = this.commonUserData.employee.street
        this.city = this.commonUserData.employee.city
        this.zip = this.commonUserData.employee.zip
        this.notes = JSON.parse(this.commonUserData.employee.notes)
        this.employeeId = this.commonUserData.employee.id
        this.clothesSizes = {
          size_shoes: this.commonUserData.employee.size_shoes,
          size_jacket: this.commonUserData.employee.size_jacket,
          size_pants: this.commonUserData.employee.size_pants,
          size_gloves: this.commonUserData.employee.size_gloves,
        }
        this.skills = this.commonUserData.employee.work_types
      }
    },
  },

  methods: {
    ...mapActions('user', ['getUser', 'onUserEmployeeDocGrid']),
    ...mapActions('commonUser', ['onCommonUserData']),
    ...mapActions('employeeDoc', ['onEmployeeDocGrid']),
    onImgReady(data) {
      this.$emit('onImgReady', data)
    },
    async downloadEployeeData() {
      this.onCommonUserData(this.userId)
      this.onEmployeeDocGrid(this.userId)
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  padding: 30px;
  display: grid;
  // height: 1240px;
  grid-template-rows: max-content max-content;
  grid-row-gap: 60px;
  &_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 30px;
    &_left {
      display: grid;
      grid-row-gap: 30px;
      align-items: start;
      grid-template-rows: repeat(8, max-content);
    }
    &_right {
      display: grid;
      grid-row-gap: 10px;
      align-items: start;
      grid-template-rows: repeat(4, max-content);
    }
  }
}
</style>
